import { bffInstance } from "../api/axiosInstance";
import { useQuery, useMutation } from "react-query";
import { useApplicationStore } from "./ApplicationStore";
import eventEmitter from "../core/eventEmitter";

export const getApplication = async (locale:string,enterpriseId:string) => {
  const response = await bffInstance.get(
    `/getApplications/${enterpriseId}?vanity=false`,
    {
      headers:{
        "Accept-Language":locale
      }
    }
  );
  return response.data;
};

export const useGetApplication = (locale:string,enterpriseId:string) => {

  const { setApplications ,setApiStatus } = useApplicationStore();

  const application = useQuery({
    queryKey: ["getApplications",locale],
    queryFn: () => getApplication(locale,enterpriseId),
    onSuccess(data) {
        const sorted = [...data].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      setApplications(sorted);
    },
    onError(data){
      setApiStatus("error")
      console.warn("useGetApplication ...",data);
      eventEmitter.emit("bffError", data);
    },
    enabled:  !!locale && !!enterpriseId
  });
  return {application};
};

export const saveAppFavorite = async (id: string, isFavorite: boolean) => {
  const res = await bffInstance.put("/favoriteApplication", {
    appId: id,
    isFavorite,
  });
  return res.data;
};

export const saveWorkflowFavorite = async (id: string, appId:string, isFavorite: boolean) => {
    const res = await bffInstance.put("/favoriteWorkflow", {
      workflowId: id,
      appId,
      isFavorite,
    });
    return res.data;
  };

export const useAppFavorite = () => {
  const { applications , setApplications} = useApplicationStore();

  const mutation = useMutation(
    ({ id, isFavorite }: { id: string; isFavorite: boolean }) =>
        saveAppFavorite(id, isFavorite),
    {
      onMutate: async ({
        id,
        isFavorite,
      }: {
        id: string;
        isFavorite: boolean;
      }) => {
        const updated = applications.map((app:any) => {
            return app.id === id
              ? { ...app, isFavorite: isFavorite }
              : app;
          });
          setApplications(updated)
      }
    }
  );

  return { mutation };
};


export const useWorkflowFavorite = () => {
    const { applications , setApplications} = useApplicationStore();
  
    const mutation = useMutation(
      ({ id, appId, isFavorite }: { id: string; appId:string; isFavorite: boolean }) =>
        saveWorkflowFavorite(id, appId, isFavorite),
      {
        onMutate: async ({
          id,
          appId,
          isFavorite,
        }: {
          id: string;
          appId:string;
          isFavorite: boolean;
        }) => {
            
            const updatedData = applications.map((item:any) => {
                if (item.id !== appId) return item;
                return {
                  ...item,
                  workflows: item.workflows.map((workflow:any) =>
                    workflow.workflowId === id
                      ? { ...workflow, isFavorite: isFavorite }
                      : workflow
                  )
                };
              });
            setApplications(updatedData)
        }
      }
    );
  
    return { mutation };
  };

